<!--
 * @Author: jzh
 * @Date: 2020-03-18 17:35:32
 * @Description: file content
 * @LastEditTime: 2021-05-06 10:17:43
 * @LastEditors: DQL
 -->
<template>
  <el-row
    type="flex"
    class="l-page l-page--nav"
  >
    <!-- 左侧导航模块 Start -->
    <el-col
      :xl="5"
      :lg="6"
      :span="10"
      class="l-page__aside"
    >
      <div
        class="l-page--inner l-page--aside"
      >
        <!-- 左侧头部 Start -->
        <div
          class="l-page__header"
        >
          <!-- 左侧标题 -->
          <h2
            class="c-page__header-title"
          >
            组织树
          </h2>
        </div>
        <!-- 左侧头部 End -->

        <!-- 左侧导航主内容 Start -->
        <div
          class="l-page__body"
        >
          <hm-page-card
            class="c-card--aside"
          >
            <!-- 树导航 Start -->
            <div
              class="c-asideTree"
            >
              <div
                class="c-asideTree__body"
              >
                <!-- tree的ref的命名根据业务名称修改 -->
                <el-tree
                  ref="tree"
                  class="c-asideTree__tree o-tree-overflow--unset"
                  node-key="deptCode"
                  highlight-current
                  check-strictly
                  lazy
                  :load="handleLoadDeptTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  @node-click="hanldeNodeClick"
                />
              </div>
            </div>
          </hm-page-card>
        </div>
      </div>
    </el-col>
    <!-- 左侧导航模块 End -->

    <!-- 右侧主面板模块 Start -->
    <el-col
      v-loading="loading"
      :xl="19"
      :lg="18"
      :span="14"
      class="l-page__panel"
    >
      <!-- 右侧内容：基础详情类布局 Start -->
      <div
        class="l-page--inner l-page--detail"
      >
        <!-- 页面头部 Start -->
        <div
          class="l-page__header c-page__header"
        >
          <!-- 页面标题 -->
          <h2
            class="c-page__header-title"
          >
            组织岗位关系维护
          </h2>

          <!-- 标题栏按钮区域 Start -->
          <div
            class="c-page__header-btns"
          >
            <el-button
              v-permission-admin-element
              type="primary"
              icon="kestrel-icon ki-save"
              @click="handleSave"
            >
              保存
            </el-button>
          </div>
          <!-- 标题栏按钮区域 End -->
        </div>
        <!-- 页面头部 End -->

        <!-- 页面主内容：详情 Start -->
        <div
          class="l-page__body l-page--detail__body"
        >
          <hm-page-card class="c-card--detail">
            <el-transfer
              v-if="showTransfer"
              ref="transfer"
              v-model="selectedRoles"
              class="c-flex-transfer"
              filterable
              filter-placeholder="请输入岗位名称"
              :data="roles"
              :props="{key: 'roleCode', label: 'roleName' }"
              :titles="['可选岗位','已选岗位']"
              @change="handleChange"
            >
              <span slot-scope="{ option }">【{{ option.roleTypeName }}】{{ option.roleName }}</span>
            </el-transfer>
          </hm-page-card>
        </div>
        <!-- 页面主内容：详情 End -->
      </div>
    </el-col>
    <!-- 右侧主面板模块 End -->
  </el-row>
</template>

<script>
import { deptRoleService, roleService, deptTree } from '@/features/system/dept/deptRole/deptRole.service.js';
export default {
  name: 'DeptRoleRelationShip', // 机构部门岗位关系维护
  data () {
    return {
      loading: false, // 页面loading状态
      showTransfer: true,

      /* 树组件配置 Start */
      // 树组件默认参数配置
      defaultProps: {
        label: 'deptName',
        children: 'children',
        isLeaf: (data, node) => {
          return !data.xjbz;
        }
      },
      /* 树组件配置 End */

      /* 表单参数 Start */
      fd: {
        deptCode: '',
        deptName: '',
        sysRoleVOList: [] // 关联关系
      },
      /* 表单参数 End */

      roles: [], // 所有的岗位
      selectedRoles: [], // 已选的岗位
      selectedChange: false // 是否修改关系
    };
  },
  methods: {
    /* 初始化部分 */
    /* 1. 部门树 Start */
    /**
     * @description: 处理加载部门树
     * @param {Object} node 包含数据的节点对象
     * @param {function} resolve 异步回调函数
     * @return {*}
     */
    handleLoadDeptTree (node, resolve) {
      this.loading = true;
      this.getDeptTree(node.data, resolve);
    },
    /**
     * @description: 读取部门树
     * @param {Object} _data 部门数据
     * @param {function} _resolve 异步回调函数
     * @return {*}
     */
    getDeptTree (_data, _resolve) {
      const params = {};
      if (_data) {
        params.deptCode = _data.deptCode;
      }
      deptTree(params)
        .then(rsp => {
          _resolve(rsp.data);
        })
        .catch(err => {
          console.error('查询组织出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /* 部门树 End */

    /* 按钮区域部分 */
    /**
     * @description: 处理机构部门树点击节点的事件
     * @param {Object} data 包含部门代码和部门名称的对象
     * @return {*}
     */
    async hanldeNodeClick (data) {
      const _this = this;
      if (_this.selectedChange) {
        _this.$confirm('该组织和岗位的关系暂未保存！确认要离开当前编辑吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.loadRolesAndRelationship(data);
          // 重置为未修改状态
          _this.selectedChange = false;
          _this.resetTransfer(); // 重置穿梭框数据（修复切换后已勾选的状态）
        });
      } else { // 首次和未修改
        _this.loadRolesAndRelationship(data);
        _this.resetTransfer(); // 重置穿梭框数据（修复切换后已勾选的状态）
      }
    },
    /**
     * @description: 重置穿梭框数据
     */
    resetTransfer () {
      this.roles = [];
      this.selectedRoles = [];
    },
    /**
     * @description:读取岗位和机构部门关系
     * @param {*}
     * @return {*}
     */
    async loadRolesAndRelationship (data) {
      this.fd.deptCode = data.deptCode;
      this.fd.deptName = `—${data.deptName}`;
      this.loading = true;
      await this.getRoles();
      await this.getRelationship(data.deptCode);
      this.loading = false;
    },
    /**
     * @description: 读取所有岗位
     * @param {*}
     * @return {*}
     */
    async getRoles () {
      return roleService.listRole()
        .then(rsp => {
          this.roles = rsp.data;
        })
        .catch(err => {
          console.error('查询所有岗位出错！', err);
        });
    },
    /**
     * @description: 读取机构部门和岗位的关系
     * @param {string} _deptCode 机构部门代码
     * @return {*}
     */
    async getRelationship (_deptCode) {
      return deptRoleService.getByDeptCode(_deptCode)
        .then(rsp => {
          this.selectedRoles = rsp.data.map((item) => { return item.roleCode; });
        })
        .catch(err => {
          console.error('查询组织对应岗位出错！', err);
        });
    },
    /**
     * @description: 处理改变事件，标注选项被改变的状态
     * @param {*}
     * @return {*}
     */
    handleChange () {
      this.selectedChange = true;
    },
    // 保存
    /**
     * @description: 保存机构部门岗位关系
     * @return {*}
     */
    handleSave () {
      this.loading = true;
      // 把字符串转成包含roleCode的对象
      this.fd.sysRoleVOList = this.selectedRoles.map((item) => { return { roleCode: item }; });

      deptRoleService.saveByDeptCode(this.fd)
        .then(rsp => {
          // 保存成功设置修改状态为false
          this.selectedChange = false;
          this.$alert('组织关联岗位保存成功！', '提示', {
            type: 'success'
          });
        })
        .catch(err => {
          console.error('保存组织关联岗位出错！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
